import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { ErrorService } from "../../../../control-core/services/error.service";
import { TranslateService } from "@ngx-translate/core";
import { NGXLogger } from "ngx-logger";
import { DireccioneModel } from "../../../models/general/cliente.model";
import { CONTROL_APP_CONST } from "../../../config/control-app.constant";
import { initWaitMe, stopWaitMe, WaitMeOptionModel } from "../../../../control-core/util/waitme.util";
import { SUCCESS_NOTIFY, notify } from "../../../../control-core/util/notify.util";
import Swal from 'sweetalert2'
import { SimpleTableConfig } from "../../../../control-core/shared/simple-table/simple-table.component";
import { AuthService } from "../../../../control-core/services/auth.service";
import { BuscarCiudadModel } from "../../../shared/buscar-ciudad/buscar-ciudad.model";

import * as cloneDeep from 'lodash/cloneDeep';
import { UserCModel } from "../../../models/user.model";
import { Subscription } from "rxjs/Subscription";
import { BuscarCiudadComponent } from "../../../shared/buscar-ciudad/buscar-ciudad.component";
import { CiudadModel, DepartamentoModel, PaisModel } from "../../../models/general/gestion-geografica.model";
import { ValidatorService } from "../../../../control-core/services/validator-service";

declare let jquery: any;
declare let $: any;

@Component({
  selector: 'app-edicion-perfil',
  templateUrl: './edicion-perfil.component.html'
})
export class EdicionclienteComponent implements OnInit {

  @ViewChild(BuscarCiudadComponent) child: BuscarCiudadComponent;

  public objCliente: UserCModel = new UserCModel();
  public objDireccionEdit: DireccioneModel = new DireccioneModel();

  public isUpdateDireccion: boolean = false;

  private _idRootPanel = '#detalleCliente';
  public titleCliente: string = '';

  nuevaCiudad: BuscarCiudadModel;
  configTablaDirecciones = new SimpleTableConfig();

  configTablaDireccionesEnvio = new SimpleTableConfig();

  public confirmaActu = this._translate.instant('CONFIR_UPDATE_DATA_LABEL');
  public confirmaDelete = this._translate.instant('CONFIR_ELIM_DIR_LABEL');
  public _YES_LABEL = this._translate.instant('YES_LABEL');
  public _NO_LABEL = this._translate.instant('NO_LABEL');

  campoRequerido = this._translate.instant("FIELD_REQUIRED");

  objectErrorPerfil = {
    nombresError: false,
    apellidosError: false,
    telefonoError: false,
    nombresText: this.campoRequerido,
    apellidosText: this.campoRequerido,
    telefonoText: this.campoRequerido
  };

  private _objCliente$Unsubscribe: Subscription = null;

  constructor(private _http: HttpClient,
              private _errorService: ErrorService,
              private _translate: TranslateService,
              private _authService: AuthService,
              private _validatorService: ValidatorService,
              private _logger: NGXLogger) {
  }

  ngOnInit() {

    this._objCliente$Unsubscribe = this._authService.userInfo$
        .subscribe((iUserInfo: UserCModel) => {
          this.objCliente = cloneDeep(iUserInfo);

          this.titleCliente = this._translate.instant('MSG_TITLE_EDICION_CLIENTE',
              {idbox: this.objCliente.idbox});

          iUserInfo.direcciones.forEach((value) => {
            this.configTablaDirecciones.data.push(value);
          });

          iUserInfo.dir_envios.forEach((value) => {
            this.configTablaDireccionesEnvio.data.push(value);
          });
        });

    this.nuevaCiudad = new BuscarCiudadModel(new CiudadModel(), new DepartamentoModel(), new PaisModel());

    this.configTablaDirecciones.columns = [
      {label: 'DIRECCION_LABEL', name: 'direccion'},
      {label: 'CODIGO_POSTAL_LABEL', name: 'zip'},
      {
        label: 'CIUDAD_LABEL', name: 'ciudad',
        options: {
          render: (data) => {
            return data.nombre + '/' + data.departamento.nombre;
          }
        }
      },
      {
        label: 'DIR_RESIDENCIA_LABEL', name: 'ciudad',
        options: {
          render: (data, index, row) => {
            if (row.principal) {
              return '<i class="material-icons">done</i>';
            } else {
              return '';
            }
          }
        }
      }
    ];

    this.configTablaDirecciones.optionColumns = [{
      label: 'EDIT_LABEL', action: (row) => {
        this.nuevaCiudad = new BuscarCiudadModel(new CiudadModel(), new DepartamentoModel(), new PaisModel());
        this.nuevaCiudad.setFromCiudadModel(cloneDeep(row.ciudad));
        this.objDireccionEdit = cloneDeep(row);

        this.isUpdateDireccion = true;
        $('#edicionDireccionModal').modal('show');
      }
    }, {
      label: 'SEL_PRINCIPAL_LABEL', action: (row) => {
        this.nuevaCiudad.setFromCiudadModel(cloneDeep(row.ciudad));
        this.objDireccionEdit = cloneDeep(row);

        this.objDireccionEdit.principal = true;

        this.updateDireccion();
      }, hidden: (row) => {
        return row.principal;
      }
    }];

    this.configTablaDireccionesEnvio.columns = [
      {
        label: 'DESTINATARIO_LABEL',
        name: 'nombres',
        options: {
          render: (data, index, rowData) => {
            return rowData.nombres + " " + rowData.apellidos;
          }
        }
      },
      {
        label: 'PHONE_FIELD_LABEL', name: 'telefono',
        options: {
          render: (data, index, rowData) => {
            if (this._validatorService.isEmpty(data)) {
              return this.objCliente.telefono;
            } else {
              return rowData.telefono;
            }
          }
        }
      },
      {label: 'DIRECCION_LABEL', name: 'direccion'},
      {label: 'CODIGO_POSTAL_LABEL', name: 'zip'},
      {
        label: 'CIUDAD_LABEL', name: 'ciudad',
        options: {
          render: (data) => {
            return data.nombre;
          }
        }
      }
    ];

    this.configTablaDireccionesEnvio.optionColumns = [{
      label: 'DELETE_LABEL', action: (row) => {
        this.delDireccion(row.id);
      }
    }];

  }

  updateBasData() {
    if (this.checkBasData()) {
      return false;
    }

    let dataUpdate = {
      identificacion: this.objCliente.identificacion,
      name: this.objCliente.name,
      lastname: this.objCliente.lastname,
      telefono: this.objCliente.telefono
    };

    Swal({
      title: '',
      html: '<span style="font-size: 15px">' + this.confirmaActu + '</span>',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: this._YES_LABEL,
      cancelButtonText: this._NO_LABEL
    }).then((result) => {
      if (result.value) {

        this._http.put<any>(`${CONTROL_APP_CONST.API_URL}updatecliente`, dataUpdate)
            .subscribe(
                (response) => {

                  this.reloadData();

                  notify(this._translate.instant(response), SUCCESS_NOTIFY);
                }, (error) => {
                  this._errorService.manejaError(error);
                }
            )
      }
    });
  }

  checkBasData() {
    let x = 0;

    this.objectErrorPerfil.nombresError = false;
    this.objectErrorPerfil.telefonoError = false;
    this.objectErrorPerfil.apellidosError = false;

    if (this.objCliente.name == '') {
      this.objectErrorPerfil.nombresError = true;
      x++;
    }
    if (this.objCliente.lastname == '') {
      this.objectErrorPerfil.apellidosError = true;
      x++;
    }
    if (this.objCliente.telefono == '') {
      this.objectErrorPerfil.telefonoError = true;
      x++;
    }

    return x > 0;
  }

  updateDireccion() {
    let dataUpdate = {
      direccion_id: this.objDireccionEdit.id,
      direccion: this.objDireccionEdit.direccion,
      ciudad_id: this.objDireccionEdit.geciudade_id,
      principal: this.objDireccionEdit.principal,
      zip: this.objDireccionEdit.zip
    };

    Swal({
      title: '',
      html: '<span style="font-size: 15px">' + this.confirmaActu + '</span>',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: this._YES_LABEL,
      cancelButtonText: this._NO_LABEL
    }).then((result) => {
      if (result.value) {

        this._http.put<any>(`${CONTROL_APP_CONST.API_URL}updateDirecciones`, dataUpdate)
            .subscribe(
                (response) => {

                  this.reloadData();

                  notify(this._translate.instant(response), SUCCESS_NOTIFY);
                }, (error) => {
                  this._errorService.manejaError(error);
                }
            )
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        stopWaitMe('#edicionDireccionModalContent');
      }
    });
  }

  delDireccion(idDir) {

    let optionWait = new WaitMeOptionModel();

    optionWait.effect = 'win8';

    initWaitMe('#edicionDireccionModalContent', optionWait);

    Swal({
      title: '',
      html: '<span style="font-size: 15px">' + this.confirmaDelete + '</span>',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: this._YES_LABEL,
      cancelButtonText: this._NO_LABEL
    }).then((result) => {
      if (result.value) {

        this._http.delete<any>(`${CONTROL_APP_CONST.API_URL}delDireccion/${idDir}`, {})
            .subscribe(
                (response) => {
                  stopWaitMe('#edicionDireccionModalContent');

                  this.reloadData();

                  notify(this._translate.instant(response), SUCCESS_NOTIFY);
                }, (error) => {

                  stopWaitMe('#edicionDireccionModalContent');
                  this._errorService.manejaError(error);
                }
            )
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        stopWaitMe('#edicionDireccionModalContent');
      }
    });

  }

  insertNewDireccion() {

    this.nuevaCiudad = new BuscarCiudadModel(new CiudadModel(), new DepartamentoModel(), new PaisModel());

    this.objDireccionEdit.zip = '';
    this.objDireccionEdit.direccion = '';

    this.isUpdateDireccion = false;

    $('#edicionDireccionModal').modal('show');
  }

  reloadData() {
    let optionWait = new WaitMeOptionModel();

    optionWait.effect = 'win8';

    initWaitMe('#tblDirecciones', optionWait);
    initWaitMe('#tblDireccionesEnvio', optionWait);

    this.configTablaDirecciones.data.splice(0, this.configTablaDirecciones.data.length);
    this.configTablaDireccionesEnvio.data.splice(0, this.configTablaDireccionesEnvio.data.length);

    this._authService.loadUserInfo();

    setTimeout(() => {
      stopWaitMe('#tblDirecciones');
      stopWaitMe('#tblDireccionesEnvio');
    }, 1000);
  }

  onCompletado(response){
    $('#edicionDireccionModal').modal('hide');

    this.reloadData()
  }

  ngOnDestroy() {
    this._objCliente$Unsubscribe.unsubscribe();
    $('.modal').modal('hide');
    $('.modal-backdrop').remove();
  }
}



// WEBPACK FOOTER //
// ./src/app/control-app/views/cliente/edicion-perfil/edicion-perfil.component.ts